import { Link } from "react-router-dom";
import mbg1Img from "../assets/mbg1.png";
import mbg2Img from "../assets/mbg2.jpg";
import mbg3Img from "../assets/mbg3.png";

export default function FoodEdu() {
  return (
    <>
      <section className="text-gray-600 body-font scroll-animate">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-col scroll-animate">
            <div className="h-1 overflow-hidden bg-gray-200 rounded">
              <div className="w-24 h-full bg-indigo-500"></div>
            </div>
            <div className="flex flex-col flex-wrap py-6 mb-12 sm:flex-row">
              <h1 className="mb-2 text-2xl font-medium text-gray-900 sm:w-2/5 title-font sm:mb-0">
                Mengenal kandungan gizi makanan <br /> bergizi gratis
              </h1>
              <p className="pl-0 text-base leading-relaxed sm:w-3/5 sm:pl-10">
                Kandungan dalam makanan bergizi memiliki peran penting
                dalam mendukung pertumbuhan fisik, perkembangan otak,
                serta menjaga daya tahan tubuh anak agar tetap aktif
                dan fokus dalam belajar setiap hari.
              </p>
            </div>
          </div>

          <div className="flex flex-wrap -mx-4 -mt-4 -mb-10 sm:-m-4">
            <div className="p-4 mb-6 md:w-1/3 sm:mb-0 scroll-animate">
              <div className="h-64 overflow-hidden rounded-lg">
                <img
                  alt="content"
                  className="object-cover object-center w-full h-full"
                  src={mbg1Img}
                />
              </div>
              <h2 className="mt-5 text-xl font-medium text-gray-900 title-font">
                Kandungan Gizi
              </h2>
              <p className="mt-2 text-base leading-relaxed">
                Hidangan ini mengandung karbohidrat kompleks, vitamin A dan C,
                serta serat tinggi dari buah dan sayur. Namun, gorengan dan saus
                kemasan berpotensi menambah lemak jenuh serta natrium berlebih.
              </p>

              <Link to={"/detail"} className="inline-flex items-center mt-3 text-indigo-500">
                Pelajari Lebih Lanjut
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>
            <div className="p-4 mb-6 md:w-1/3 sm:mb-0 scroll-animate">
              <div className="h-64 overflow-hidden rounded-lg">
                <img
                  alt="content"
                  className="object-cover object-center w-full h-full"
                  src={mbg2Img}
                />
              </div>
              <h2 className="mt-5 text-xl font-medium text-gray-900 title-font">
                Kandungan Gizi
              </h2>
              <p className="mt-2 text-base leading-relaxed">
                Hidangan ini terdiri dari nasi kuning, telur suwir, daging berbumbu,
                sayuran segar, pisang, dan susu cokelat sebagai penambah energi dan nutrisi harian.
              </p>
              <Link to={"/detail"} className="inline-flex items-center mt-3 text-indigo-500">
                Pelajari Lebih Lanjut
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>

            <div className="p-4 mb-6 md:w-1/3 sm:mb-0 scroll-animate">
              <div className="h-64 overflow-hidden rounded-lg">
                <img
                  alt="content"
                  className="object-cover object-center w-full h-full"
                  src={mbg3Img}
                />
              </div>
              <h2 className="mt-5 text-xl font-medium text-gray-900 title-font">
                Kandungan Gizi
              </h2>
              <p className="mt-2 text-base leading-relaxed">
                Menu ini terdiri dari kentang rebus, mi goreng, telur dadar, kue mini,
                dan susu cair kombinasi karbohidrat kompleks, protein, dan kalsium yang baik.
              </p>
              <Link to={"/detail"} className="inline-flex items-center mt-3 text-indigo-500">
                Pelajari Lebih Lanjut
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
